import styled, { keyframes } from 'styled-components';
import { IThemeProvider } from '../../styles/theme';

const move = keyframes`
  from {
    left: -320px;
  }

  to {
    left: 0;
  }
`;

export const ToastMessageCont = styled.div`
  position: absolute;
  transition-timing-function: cubic-bezier(0.22, 1, 0.36, 1);
  animation: ${move} 0.15s linear;
  z-index: 1000;
  width: 320px;
  ${({ theme }: IThemeProvider) => `
       left: ${theme.layout.spacing.decy};
       bottom: ${theme.layout.spacing.decy};
    `};
`;
